import { useMemo } from "react";
import { KeyedMutator } from "swr";

import { API_URL } from "constants/api";
import { useSwr } from "hooks/useSwr";

const useGetUsers = (): {
  accountList: Account[];
  error: Error;
  mutate: KeyedMutator<Account[]>;
} => {
  const { data, error, mutate } = useSwr<Account[]>(`${API_URL}/user/account/list`);

  const accountList = useMemo(
    () => (data ? [{ id: "ALL", name: "すべて", department: "すべて" }, ...data] : []),
    [data]
  );

  return { accountList, error, mutate };
};

export default useGetUsers;
